export const InfoIcon = ({ className }: { className: string }) => {
  return (
    <svg className={className} viewBox='0 0 28 27' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <ellipse cx='13.6132' cy='13.5' rx='13.6132' ry='13.5' fill='url(#paint0_linear_40048_6392)' />
      <path
        d='M11.1113 20V18.4969L12.4402 18.222V11.8706L11.0013 11.5957V10.0834H14.9331V18.222L16.262 18.4969V20H11.1113ZM12.3486 7.91131V5.70254H14.9331V7.91131H12.3486Z'
        fill='white'
      />
      <defs>
        <linearGradient
          id='paint0_linear_40048_6392'
          x1='0'
          y1='27'
          x2='27.2229'
          y2='27.0035'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#C71CB8' />
          <stop offset='1' stop-color='#FE139C' />
        </linearGradient>
      </defs>
    </svg>
  )
}
